import React from "react";
import { Dialog, DialogTitle, DialogContent, DialogActions, Button } from "@mui/material";

interface DeleteDialogProps {
  open: boolean;
  onClose: () => void;
  onDelete: () => void;
}

const DeleteDialog: React.FC<DeleteDialogProps> = ({ open, onClose, onDelete }) => (
  <Dialog open={open} onClose={onClose}>
    <DialogTitle>Delete Prospect</DialogTitle>
    <DialogContent>
      Are you sure you would like to delete this prospect?
    </DialogContent>
    <DialogActions>
      <Button onClick={onClose} color="primary">
        Cancel
      </Button>
      <Button onClick={onDelete} variant="outlined" color="error">
        Delete
      </Button>
    </DialogActions>
  </Dialog>
);

export default DeleteDialog;
